<ion-content class="bg-color ion-content">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <ng-container *ngIf="itemList.embedurl; else noRoute">
            <a href="javascript:void(0)" routerLink="{{ itemList.url }}">
              {{ itemList.label }}
            </a>
          </ng-container>
          <ng-template #noRoute>
            <a style="text-decoration: none;" href="javascript:void(0)">
              {{ itemList.label }}
            </a>
          </ng-template>
        </li>
      </ul>
    </div>
    <div class="content-grid">
      <mat-card>
        <mat-card-title class="mc-title">
          <span class="table-header">Integration Bridge</span>
          <span class="total-count"
            *ngIf="integrationDataSource?.length > 0">{{integrationDataSource?.length}}/{{totalIntegration}}</span>
        </mat-card-title>
        <mat-card-content class="mc-content">
          <div class="table-container">
            <div class="filter-container">
              <div class="button-container">
                <button mat-raised-button class="add-button" id="ib_list_add_btn" (click)="addIntegration()"
                  *ngIf="ibAddEnable"> Add
                </button>
                <!-- <button mat-raised-button class="clear-button"> Clear Search</button> -->
                <div *ngIf="bubbleshow && ibAddEnable" class="box">
                  <span class="cancel-help-popup" id="ib_list_close_bubble" (click)="closebubblecross()">&times;</span>
                  <p>Click "Add" button to create new integration bridge</p>
                  <button mat-raised-button style="float: right;" id="ib_list_try_out" (click)="closebubble()">Try
                    Out</button>
                </div>
                <button mat-raised-button class="add-button" style="margin-right: 10px;" *ngIf="ibAddEnable && importAndExportIBEnableFromENV">
                  <input type="file" #fileInput (change)="onFileSelect($event)"/>
                  <img class="icon-import" matTooltip="Import API Catalog" matTooltipPosition="above" src="assets/images/import.png" *ngIf="ibEditEnable"> <span style="margin-left: 5px;">Import </span>
                  <!-- <mat-icon class="icon edit" matTooltip="Import API catalog" matTooltipPosition="above" *ngIf="ibEditEnable"> get_app </mat-icon> Import  -->
                </button>
              </div>

              <div class="search-container">
                <mat-form-field appearance="fill" class="non-fill">
                  <mat-label>Search</mat-label>
                  <input matInput type="text" placeholder="Search by integration bridge, source and target"
                    id="ib_list_search_input" [(ngModel)]="search" (ngModelChange)="getSearchOnChange($event)">
                  <button *ngIf="search" matSuffix mat-icon-button aria-label="Clear" id="ib_list_clear_search"
                    (click)="clearSearch()">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>

              <div class="reset-fr">
                <mat-icon matTooltip="Refresh Integration Bridge List" matTooltipPosition="above" class="icon"
                  (click)="getAllIntegration(true)" id="ib_list_refresh_ib">
                  replay </mat-icon>
                <!-- <button mat-raised-button class="add-button" id="ib_list_add_btn" (click)="getAllIntegration(true)"> Reset
                </button> -->
              </div>
            </div>
            <table mat-table matTableResponsive [dataSource]="integrationDataSource" matSort matSortDisableClear
              matSortDirection="desc" (matSortChange)="sortColumn($event)">

              <ng-container matColumnDef="ic_name">
                <th mat-header-cell *matHeaderCellDef> Integration Bridge </th>
                <td mat-cell *matCellDef="let element"><span matTooltip={{element.integration_bridge_description}} matTooltipPosition="above" >{{element.alias_integration_bridge_name}}</span></td>
              </ng-container>

              <ng-container matColumnDef="source_name">
                <th mat-header-cell *matHeaderCellDef> Source Name </th>
                <td mat-cell *matCellDef="let element">{{element.source_name}} </td>
              </ng-container>

              <ng-container matColumnDef="target_name">
                <th mat-header-cell *matHeaderCellDef> Target Name </th>
                <td mat-cell *matCellDef="let element">{{element.target_name}} </td>
              </ng-container>

              <ng-container matColumnDef="source_type">
                <th mat-header-cell *matHeaderCellDef> Source Type </th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="element.source_type == 1">
                    API 
                  </span>
                  <span *ngIf="element.source_type == 2">
                    Database
                  </span>
                  <span *ngIf="element.source_type == 3">
                    Bizintel360 Data Lake Source
                  </span>
                  <span *ngIf="element.source_type == 4">
                    Websocket
                  </span>
                  <span *ngIf="element.source_type == 5">
                    Email
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="target_type">
                <th mat-header-cell *matHeaderCellDef> Target Type </th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="element.target_type == 1">
                    API 
                  </span>
                  <span *ngIf="element.target_type == 2">
                    Database
                  </span>
                  <span *ngIf="element.target_type == 3">
                    Bizintel360 Data Lake Ingestion
                  </span>
                  <span *ngIf="element.target_type == 4">
                    Email
                  </span>
                  <span *ngIf="element.target_type == 5">
                    No Target
                  </span>
                </td>
              </ng-container>

              <!-- <ng-container matColumnDef="updated_date">
                <th mat-header-cell *matHeaderCellDef> Updated Date </th>
                <td mat-cell *matCellDef="let element">{{element.updated_date | date: 'medium'}} </td>
              </ng-container> -->

              <ng-container matColumnDef="updated_date">
                <th mat-header-cell class="th-center-align" *matHeaderCellDef mat-sort-header
                  sortActionDescription="Sort by Updated Date" >
                  Updated Date
                </th>
                <td mat-cell *matCellDef="let element">
                  <span class="updated_date" *ngIf="element.updated_date"> {{element.updated_date | date: 'medium'}}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="updated_by">
                <th mat-header-cell *matHeaderCellDef> Updated By </th>
                <td mat-cell *matCellDef="let element">
                  <span
                    *ngIf="element.updated_by != '' && element.updated_by != undefined">{{element?.updated_by}}</span>
                  <span
                    *ngIf="element.updated_by == '' || element.updated_by == undefined">{{element?.created_by}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell class="th-center-align status" *matHeaderCellDef mat-sort-header
                  sortActionDescription="Sort by Status"> Status </th>
                <td mat-cell class="td-center-align status" *matCellDef="let element">
                  <span class="service-status start" *ngIf="element.service_status == 1"></span>
                  <span class="service-status stop"
                    *ngIf="element.service_status == 0 || element.service_status == 2"></span>
                </td>
              </ng-container>

              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox (change)="$event ? selectAllIB($event) : null"
                    [checked]="ibselection.hasValue() && checkIsAllIBSelected()"
                    [indeterminate]="ibselection.hasValue() && !checkIsAllIBSelected()"
                    style="transform: scale(0.8); margin-left: -10px;">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? ibselection.toggle(row) : null"
                    [checked]="ibselection.isSelected(row)" style="transform: scale(0.8); margin-left: -10px;">
                  </mat-checkbox>
                </td>
              </ng-container>



              <!-- <ng-container matColumnDef="phone_no">
                <th mat-header-cell *matHeaderCellDef> Phone </th>
                <td mat-cell *matCellDef="let element">{{element.phone_no}} </td>
              </ng-container> -->

              <ng-container matColumnDef="action" >
                <th mat-header-cell *matHeaderCellDef>
                  <img class="icon-export edit" matTooltip="Export Integration Bridge" matTooltipPosition="above" src="assets/images/export.png" *ngIf="ibAddEnable && importAndExportIBEnableFromENV && ibEditEnable"
                  (click)="exportIB()" style="cursor: pointer;">
                  <!-- <mat-icon class="icon edit" matTooltip="Export IB" matTooltipPosition="above" 
                    *ngIf="ibAddEnable && importAndExportIBEnableFromENV && ibEditEnable"
                    (click)="exportIB()" style="cursor: pointer;">

                    publish
                  </mat-icon> -->
                </th>

                <td mat-cell *matCellDef="let element">
                  <!-- <button mat-icon-button matTooltip="Start" matTooltipPosition="above"
                    *ngIf="(element.service_status == 0 && ibEditEnable) || (element.service_status == 2 && ibEditEnable)"> -->
                  <!-- <mat-icon matTooltip="Start" matTooltipPosition="above"
                    *ngIf="(element.service_status == 0 && ibStartEnable) || (element.service_status == 2 && ibEditEnable)"
                    class="icon play" id="ib_list_start_service"
                    (click)="startService(element.id, element.py_conf_filename)">
                    play_arrow </mat-icon> -->
                    <mat-icon matTooltip="Start" matTooltipPosition="above" [matMenuTriggerFor]="runOnce_feat ? runMenu : null"
                    *ngIf="(element.service_status == 0 && ibStartEnable) || (element.service_status == 2 && ibEditEnable)"
                    class="icon play" id="ib_list_start_service" (click)="!runOnce_feat && startService(element.id, element.py_conf_filename)">
                    play_arrow </mat-icon>

                  <!-- </button> -->
                  <!-- <button mat-icon-button matTooltip="Stop" matTooltipPosition="above" -->
                  <!-- *ngIf="element.service_status == 1 && ibEditEnable"> -->
                  <mat-icon matTooltip="Stop" matTooltipPosition="above"
                    *ngIf="(element.service_status == 1 && ibStopEnable)" class="icon stop"
                    (click)="stopService(element.id, element.py_conf_filename)" id="ib_list_stop_service">
                    stop </mat-icon>
                  <!-- </button> -->
                  <!-- <button mat-icon-button *ngIf="ibEditEnable" matTooltip="Refresh" matTooltipPosition="above"> -->
                  <mat-icon *ngIf="ibEditEnable" matTooltip="Refresh" matTooltipPosition="above" class="icon restart"
                    (click)="showRefreshServiceAlert(element.id)" id="ib_list_refresh"> replay </mat-icon>
                  <!-- </button> -->
                  <!-- <button mat-icon-button *ngIf="ibEditEnable" matTooltip="Status" matTooltipPosition="above"> -->
                  <mat-icon *ngIf="ibEditEnable" matTooltip="Status" matTooltipPosition="above" class="icon status"
                    (click)="statusService(element.id, element.py_conf_filename)" id="ib_list_status">
                    access_time </mat-icon>
                  <!-- </button> -->
                  <!-- <button mat-icon-button *ngIf="ibEditEnable" matTooltip="Edit" matTooltipPosition="above"> -->
                  <mat-icon *ngIf="ibEditEnable" matTooltip="Edit" matTooltipPosition="above" class="icon edit"
                    (click)="editIntegration(element.id)" id="ib_list_edit"> edit </mat-icon>
                  <!-- </button> -->
                  <!-- <button mat-icon-button matTooltip="Copy" matTooltipPosition="above" *ngIf="ibEditEnable"> -->
                  <mat-icon matTooltip="Copy" matTooltipPosition="above" *ngIf="ibEditEnable && !freeTrailMode"
                    class="icon copy" (click)="confirmCopyIB(element)" id="ib_list_copy"> file_copy </mat-icon>
                  <!-- </button> -->
                  <!-- <button mat-icon-button *ngIf="ibDetailsEnable" matTooltip="View More" matTooltipPosition="above"> -->
                  <mat-icon *ngIf="ibDetailsEnable" matTooltip="View More" matTooltipPosition="above" class="icon info"
                    (click)="getIntegrationDetails(element.id)" id="ib_list_view_more"> info </mat-icon>
                  <!-- </button> -->
                  <!-- <button mat-icon-button *ngIf="ibEditEnable" matTooltip="Logs" matTooltipPosition="above"> -->
                  <mat-icon *ngIf="isDownloadLogsEnabled" matTooltip="Logs" matTooltipPosition="above" class="icon info"
                    id="ib_list_download_logs" [matMenuTriggerFor]="logMenu"> save_alt </mat-icon>
                  <!-- </button> -->
                  <!-- <button mat-icon-button *ngIf="ibEditEnable" matTooltip="Live Streaming logs"
                    matTooltipPosition="above"> -->
                  <mat-icon *ngIf="isStreamingLogsEnabled" matTooltip="Live Streaming logs" matTooltipPosition="above"
                    class="icon logs"
                    (click)="streamingLogs(element.id, element.alias_integration_bridge_name,element.service_status)"
                    id="ib_list_streaming_logs">
                    <img src="assets/images/streaming_logs.svg">
                  </mat-icon>
                  <!-- <img src="assets/images/streaming_logs.svg" (click)="liveStreamLogs(element.id)" style="width:38px;height:38px"> -->
                  <!-- </button> -->
                  <!-- <button mat-icon-button *ngIf="ibDeleteEnable" matTooltip="Delete" matTooltipPosition="above"> -->
                  <mat-icon matTooltip="Delete" *ngIf="ibDeleteEnable" matTooltipPosition="above" class="icon delete"
                    (click)="confirmDelete(element.id)" id="ib_list_delete"> delete </mat-icon>
                  <!-- </button> -->

                  <mat-menu #logMenu="matMenu" xPosition="before">
                    <!-- <button mat-menu-item (click)="downloadLogs(element.id)">Download Logs</button> -->
                    <button mat-menu-item (click)="downloadLogFile(element.id)">Download Log File</button>
                    <button mat-menu-item (click)="confirmClearLogsIB(element.id)">Clear Logs</button>
                  </mat-menu>
                  <mat-menu #runMenu="matMenu" xPosition="before">
                    <button mat-menu-item (click)="startService(element.id, element.py_conf_filename)">Run</button>
                    <button mat-menu-item (click)="runOnce(element.id)">Run Once</button>
                  </mat-menu>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="integrationDisplayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: integrationDisplayedColumns;"></tr>
            </table>



            <table *ngIf="!loading">
              <tr *ngIf="!integrationDataSource?.length">
                <td style="text-align: center;" [attr.colspan]="integrationDisplayedColumns.length">
                  No Records Found
                </td>
              </tr>
            </table>
          </div>
        </mat-card-content>
        <!-- <div *ngIf="totalIntegration > 5" class="load-more-bx">
          <button mat-raised-button class="load-more" (click)="loadMore()">Load More</button>
        </div> -->
        <ion-infinite-scroll *ngIf="totalIntegration > 10" threshold="150px" (ionInfinite)="loadMore($event)">
          <ion-infinite-scroll-content loadingSpinner="dots">
          </ion-infinite-scroll-content>
        </ion-infinite-scroll>
      </mat-card>
      <!-- <app-about-page *ngIf="hide1200"></app-about-page> -->
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>